export const products = [
  {
    title: "pharmtrix-wholesale",
    description: "Pharmacy Inventory Management. Medication tracking, inventory management, and dispensing for pharmacies and healthcare providers"
  },
  {
    title: "pharmtrix-retail",
    description: "Pharmacy Inventory Management. Medication tracking, inventory management, and dispensing for pharmacies and healthcare providers"
  },
  {
    title: "centrix",
    description: "Next-Gen Health Management. Centralized solutions for your hospital practice. Seamless for your entire medical ecosystem",
    status: "Coming Soon"
  },
  {
    title: "billtrix",
    description: "Medical Accounting Solutions. Streamline your accounting processes with our comprehensive medical billing software",
    status: "Coming Soon"
  },
  {
    title: "labtrix",
    description: "Managing all laboratory and imaging operations in one place. Efficient handling of all your medical results",
    status: "Coming Soon"
  }
]; 